import { Alert, AlertDescription, AlertIcon, AlertTitle, Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

// Sits in the same below-the-header notice slot as PublicationStatusBanner and mirrors its styling,
// since the two are status-exclusive (this shows for a draft a non-creator can't edit; that one for
// pending/failed publication) and should read as one consistent banner pattern on this page.
export const DraftNoEditAccessBanner = () => {
  const { t } = useTranslation();
  return (
    <Box mt="4">
      <Alert status="info" rounded="md" fontSize="sm" alignItems="flex-start">
        <AlertIcon />
        <Box>
          <AlertTitle>{t("This procurement is still a draft")}</AlertTitle>
          <AlertDescription>
            {t("You don't have permission to edit it. Ask an administrator in your organization for edit access.")}
          </AlertDescription>
        </Box>
      </Alert>
    </Box>
  );
};
